export default __webpack_public_path__ + "static/media/ic_madeira.ca85e405.svg";